import { createI18n } from "vue-i18n"
import dayjs from 'dayjs';
import zhCn from "./lang/zh-cn"
import en from "./lang/en"
import { getLocale } from '@/utils/dom';

const i18n = createI18n({
  legacy: false,
  locale: getLocale(),
  messages: {
    'zh-cn': zhCn,
    en,
  },
});

export function t (key: string, options?: any) {
  return i18n.global.t(key, ['string', 'number'].includes(typeof options) ? [options] : options)
}

export default i18n
